import { useState, useEffect } from "react";
import Joi from "joi-browser";
// import Form from "V2.0/components/Form";
import * as voiceapiservice from "V2.0/services/voiceAPIServices";
import { message } from "antd";
import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { DialogTitleWithClose } from "V2.0/components/DialogTitleWithClose";
import { showErrorToast } from "V2.0/utils";
import { Button } from "V2.0/common/button";
import { PencilIcon, PlusIcon } from "@heroicons/react/24/outline";
import CustomAttributesAdd from "./CustomAttributesAdd";
import { useForm } from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form/useForm";
import Form from "V2.0/HomePages/Assistants/AssistantTools/CustomAPIs/components/Form";
import ReactJsonPretty from "react-json-pretty";
// import { processPromptForAttributes } from "./utils";
// import moment from "moment-timezone";
import { getTestCallVariables } from "./utils";

const schema = {
  fromNumber: Joi.string().required().label("From Number"),
  toNumber: Joi.string().required().label("To Number"),
};

function TestVoice({
  projectId,
  open,
  onClose,
  assistantId,
  prompt,
  assistantTimezone,
  voiceSettings,
  fromNumbers,
}) {
  const [inputField, setInputField] = useState({
    fromNumber: "",
    toNumber: "",
  });
  const [openAttributes, setOpenAttributes] = useState(false);
  const [attributes, setAttirbutes] = useState({});

  const { data, error, handleChange, validate } = useForm(inputField, schema);

  useEffect(() => {
    const str = `${prompt} ${voiceSettings.welcomeMessageSettings.outboundWelcomeMessages[0]}`;

    // const attributes = processPromptForAttributes(str);
    // setAttirbutes(
    //   attributes.reduce(function (acc, attr) {
    //     if (attr === "currentTime") {
    //       const now = moment().tz(assistantTimezone);
    //       const currentTime = now.format("YYYY-MM-DD HH:mm:ss dddd");
    //       return { ...acc, [attr]: currentTime };
    //     }
    //
    //     return { ...acc, [attr]: "" };
    //   }, {})
    // );
    // }, [prompt, voiceSettings, assistantTimezone]);
    const attributes = getTestCallVariables(str, "phone");
    setAttirbutes(
      attributes.reduce(function (acc, attr) {
        return { ...acc, [attr]: "" };
      }, {})
    );
  }, [prompt, voiceSettings]);

  const [loading, setLoading] = useState(false);

  const [errorMessage] = useState({});

  const template = [
    {
      name: "fromNumber",
      label: "From Number",
      type: "select",
      placeholder: "+1123456789",
      options: [
        { id: 0, label: "(None Selected)", value: "" },
        ...fromNumbers.map((num, idx) => {
          return { id: idx + 1, label: num, value: num };
        }),
      ],
    },
    {
      name: "toNumber",
      label: "To Number",
      description: "Include Country Code (e.g. +1)",
      type: "text",
      placeholder: "+1123456789",
    },
  ];

  const handleCall = async () => {
    const payload = {
      ...data,
      attributes,
    };

    setLoading(true);
    try {
      const response = await voiceapiservice.placeVoiceCall({
        workspaceId: projectId,
        assistantId,
        payload,
      });
      if (response.status === 201) {
        message.success("We have made the call. You will receive it soon.");
        setLoading(false);
        onClose();
      } else if (response.status === 202) {
        message.info(
          response.data?.msg ?? `Call to ${data.toNumber} is been queued`
        );
        setLoading(false);
        onClose();
      }
    } catch (ex) {
      showErrorToast(ex, "Failed to make call");
      setLoading(false);
    }
  };

  const isPlaceCallDisabled = data.fromNumber === "" || data.toNumber === "";

  return (
    <>
      {open && (
        <Dialog
          open={open}
          onClose={onClose}
        >
          <DialogTitle>
            <DialogTitleWithClose
              title="Talk with Assistant"
              onClose={onClose}
            />
          </DialogTitle>
          <DialogBody>
            <Form
              data={data}
              template={template}
              handleChange={handleChange}
              error={error}
            />

            {Object.keys(attributes).length > 0 && (
              <div className="mt-4 space-y-4 border rounded-lg">
                <div className="flex items-center justify-between px-4 py-2 bg-gray-50 rounded-t-lg">
                  <p className="text-sm font-medium">Custom Variables</p>
                  <Button
                    color="white"
                    onClick={() => setOpenAttributes(true)}
                  >
                    <PencilIcon /> Edit
                  </Button>
                </div>
                <div className="text-gray-500 text-sm p-4 max-h-40 overflow-scroll">
                  <ReactJsonPretty
                    data={attributes}
                    theme={{
                      main: "line-height:20px",
                      string: "color:oklch(48.8% 0.243 264.376)",
                      key: "color:oklch(70.5% 0.015 286.067)",
                    }}
                  />
                </div>
              </div>
            )}
          </DialogBody>
          <DialogActions>
            <Button
              disabled={isPlaceCallDisabled || loading}
              loading={loading}
              onClick={handleCall}
            >
              Place Call
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {openAttributes && (
        <CustomAttributesAdd
          parametersInitialValues={attributes}
          template={`${prompt} ${voiceSettings.welcomeMessageSettings.outboundWelcomeMessages[0]}`}
          callType="phone"
          onUpdateParameters={function (data) {
            setAttirbutes(data);
          }}
          onClose={function () {
            setOpenAttributes(false);
          }}
        />
      )}
    </>
  );
}

export { TestVoice };